import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ServicesContent } from '../../molecules';
import styles from './ServicesSection.module.css';

export const ServicesSection: React.FC = () => {
  const navigate = useNavigate();

  const handleCtaClick = () => {
    navigate('/contact');
  };

  return (
    <section className={styles.servicesSection} aria-label="Our Services">
      <div className={styles.container}>
        <ServicesContent onCtaClick={handleCtaClick} />
      </div>
    </section>
  );
};
